<div class="flip-card">
  <div class="flip-card-inner" [ngClass]="flipped ? 'flip-card-true' : null">
    <mat-card class="widget-card flip-card-front">
      <mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title col-auto">Hidrografia</div>
          <div class="flex-fill"></div>
          <mat-button-toggle-group
            *ngIf="selectedVelocityUnit"
            [value]="selectedVelocityUnit"
            class="mr-2 unit-toggle"
            (change)="velocityUnitChanged($event.value)"
          >
            <mat-button-toggle value="nós">nós</mat-button-toggle>
            <mat-button-toggle value="m/s">m/s</mat-button-toggle>
            <mat-button-toggle value="km/h">km/h</mat-button-toggle>
          </mat-button-toggle-group>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = true">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content>
        <div
          class="row d-flex justify-content-center"
          style="min-height: 200px; margin: 10px"
        >
          <div
            class="col-lg-3 col-md-12 row d-flex justify-content-center align-items-center m-lg-0 mb-lg-2 p-2"
            [ngClass]="isLastValuesModeled ? '' : 'modeled-box'"
          >
            <div
              *ngIf="!isLastValuesModeled"
              class="row d-flex justify-content-center align-items-center mb-2 mr-1 ml-1"
            >
              <b class="small-info-bold">Valor medido </b>
              <span class="small-info"
                >a {{ lastValuesDate | date: "dd/MM/yyyy 'às' HH:mm":"en" }}
              </span>
              <i
                class="fas fa-exclamation-triangle ml-2"
                *ngIf="!isDataUnderTolerance()"
                matTooltip="A comunicação com a fonte de dados encontra-se temporariamente indisponível"
                style="color: #FFD43B; cursor: pointer"
              ></i>
              <i
                (click)="flipped = true"
                *ngIf="isDataUnderTolerance()"
                class="fas fa-info-circle ml-2 fa-lg"
                style="color: white; cursor: pointer"
              ></i>
            </div>
            <div
              *ngIf="isLastValuesModeled"
              class="row d-flex justify-content-center align-items-center small-info mb-2"
            >
              <b class="small-info-bold">Valor previsto </b>
              <span class="small-info"
                >para {{ lastValuesDate | date: "dd/MM/yyyy 'às' HH:mm":"en" }}
              </span>
              <i
                (click)="flipped = true"
                class="fas fa-info-circle ml-2 fa-lg"
                style="color: white; cursor: pointer"
              ></i>
            </div>
            <div class="parameter-title col-12 mb-1" *ngIf="checkExists(2.1)">
              Nível do mar:
              <div class="value d-flex justify-content-center">
                <i class="far fa-wave-sine theme-fa-accent"></i
                ><span>
                  {{ mappedData.get(2.1)[0] | getSerieValue }}
                </span>
              </div>
            </div>
            <div
              class="parameter-title col-12 mt-1 mb-1"
              *ngIf="checkExists(2.3)"
            >
              Direção da corrente:
              <div class="value d-flex justify-content-center">
                <i
                  class="fas fa-location-circle theme-fa-accent"
                  [style.transform]="'rotate(' + getRotation(2.3) + ')'"
                ></i>
                <span>
                  {{ mappedData.get(2.3)[0] | getSerieValue }}
                  {{ mappedData.get(2.3)[0] | directionCompassRose : true }}
                </span>
              </div>
            </div>
            <div class="parameter-title col-12" *ngIf="checkExists(2.4)">
              Intensidade da corrente:
              <div class="value d-flex justify-content-center">
                <i class="fas fa-tachometer-alt-fast theme-fa-accent"></i
                ><span>
                  {{ mappedData.get(2.4)[0] | getSerieValue : selectedVelocityUnit }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg col-md-12 widget-card-soft mt-lg-0 mt-3 ml-lg-3">
            <p class="row sub-title">Tabela de Maré:</p>
            <div class="row">
              <div class="col-lg-6 col-md-12 mt-2 mr-0 pr-1">
                <div class="sub-sub-title">HOJE</div>
                <table
                  mat-table
                  #table
                  [dataSource]="todayTides"
                  class="mat-elevation-z8"
                  style="width: 100%"
                >
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Hora</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.date | date: "HH:mm":"en" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>Altura [m] *</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.value | number: "1.2-2":"en" }}
                      {{
                        row.stormSurge != null
                          ? (row.stormSurge | signPositiveNegative)
                          : ""
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.value | tideEvent }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="['date', 'value', 'type']"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: ['date', 'value', 'type']"
                  ></tr>
                </table>
              </div>

              <div class="col-lg-6 col-md-12 mt-2 ml-0 pl-1">
                <div class="sub-sub-title">AMANHÃ</div>
                <table
                  mat-table
                  #table
                  [dataSource]="tomorrowTides"
                  class="mat-elevation-z8"
                  style="width: 100%"
                >
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Hora</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.date | date: "HH:mm":"en" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef>Altura [m] *</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.value | number: "1.2-2":"en" }}
                      {{
                        row.stormSurge != null
                          ? (row.stormSurge | signPositiveNegative)
                          : ""
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.value | tideEvent }}
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="['date', 'value', 'type']"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: ['date', 'value', 'type']"
                  ></tr>
                </table>
              </div>
              <!-- <p class="row" style="color: white; margin-left: 15px; margin-top: 10px;">*Horas em UTC/GMT+1</p> -->
            </div>
            <span class="col-12 mt-3 small-info"
              >* Tabela de maré do Instituto Hidrográfico para o marégrafo {{ projectSettings.table_name }} (sobre-elevação
              prevista pelo modelo numérico)</span
            >
          </div>
        </div>
        <p class="sub-title">Previsão</p>
        <hr />
        <div
          style="
            height: 450px;
            background-color: rgba(0, 0, 0, 0.5);
            margin: -10px;
          "
        >
          <div id="hidrographyChart" style="width: 100%; height: 100%"></div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="widget-card flip-card-back"
      ><mat-card-title class="container-fluid">
        <div class="row d-flex align-items-center" style="margin: -5px">
          <div class="title-negative col-auto">Hidrografia</div>
          <div class="flex-fill"></div>
          <button mat-raised-button class="mr-2" (click)="openMap()">
            <i class="fas fa-map fa-lg"></i>
          </button>
          <button mat-raised-button (click)="flipped = false">
            <i class="fas fa-info fa-lg"></i>
          </button>
        </div>
      </mat-card-title>
      <hr />
      <mat-card-content
        ><app-hydrography-info></app-hydrography-info> </mat-card-content
    ></mat-card>
  </div>
</div>
